import { useState, useEffect } from 'react';

const useEmployeeInfo = (employeeId) => {
  const [employeeInfo, setEmployeeInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!employeeId) return;

    const fetchEmployeeInfo = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/employee/${employeeId}`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();
          setEmployeeInfo(data.data);
          setError(null);
        } else {
          setError('Failed to fetch employee info');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch employee info');
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeeInfo();
  }, [employeeId]);

  return { employeeInfo, loading, error };
};

export default useEmployeeInfo; 